import React from 'react';
import { Card, CardContent, CircularProgress, Container, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import * as Survey from 'survey-react';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  BultenDetay: {
    marginTop: theme.spacing(1)
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function CookerInformationForm({ Id, FisNo,className }) {

  const classes = useStyles();
  const [anketData, setAnketData] = useState({});
  const [formData, setFormData] = useState({});
  const [anketBitti, setAnketBitti] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mesaj, setMesaj] = useState('Form Başarıyla Tamamlandı.');




  const handleAnketBitti = (MesajParam = "Form Başarıyla Kaydedildi.") => {
    setAnketBitti(true);
    setMesaj(MesajParam);
  };

  const GetArtemisForm = useCallback(() => {
   
    setLoading(true);
    if (FisNo !== undefined) {
      axios.get(`GetArtemisForm/${Id}/${FisNo}`)
        .then((response) => {
          let res = response.data;
          if (typeof res === "string") {
            handleAnketBitti(res);
            setLoading(false);
            return;
          }
          
          // Güvenli JSON parse - undefined veya geçersiz değerlerde hata vermez
          const jsonStr = res?.[0]?.json;
          const formDataStr = res?.[0]?.FormData;
          
          if (!jsonStr || jsonStr === 'undefined' || jsonStr === 'null') {
            handleAnketBitti("Form verileri alınamadı. Lütfen tekrar deneyiniz.");
            setLoading(false);
            return;
          }
          
          let anketData = {};
          let formData = {};
          
          try {
            anketData = JSON.parse(jsonStr);
          } catch (parseError) {
            console.warn('Form JSON parse hatası:', parseError.message);
            handleAnketBitti("Form verisi okunamadı. Lütfen tekrar deneyiniz.");
            setLoading(false);
            return;
          }
          
          try {
            if (formDataStr && formDataStr !== 'undefined' && formDataStr !== 'null') {
              formData = JSON.parse(formDataStr);
            }
          } catch (parseError) {
            console.warn('FormData JSON parse hatası:', parseError.message);
            formData = {};
          }
          
          if (anketData.pages === undefined) {
            handleAnketBitti("Merkezden Form Bilgileri Alınamadı!..");
          }
          setAnketData(anketData);
          setFormData(formData);
          setLoading(false);
        })
        .catch((error) => {
          console.warn('Form yükleme hatası:', error.message);
          handleAnketBitti("Form yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.");
          setLoading(false);
        })
    }
  }, [Id, FisNo]);

  useEffect(() => {
    GetArtemisForm();
  }, [GetArtemisForm]);

  const onComplete = (survey) => {
    setLoading(true);
    const data = {
      Data: survey.data,
      FormTipi: Id,
      FisNo: FisNo,
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisForm', { jsonString: JSON.stringify(data) }, config)
      .then(() => {
        handleAnketBitti();
        setLoading(false);
      })
  };

  const defaultThemeColors = Survey
    .StylesManager
    .ThemeColors.default;
  defaultThemeColors['$main-color'] = '#FF9800';
  defaultThemeColors['$main-hover-color'] = '#FF9800';
  defaultThemeColors['$text-color'] = '#424242';

  Survey
    .StylesManager
    .applyTheme();
  const model = new Survey.Model(anketData);
  model.locale = 'tr';


  return (
    <Page className={classes.root}>
      <Container maxWidth="lg">
        <Card
          className={clsx(classes.root, className)}
        >          <Divider />
          {FisNo ?
            <div className={classes.content}>
              {
                loading && <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }} />
              }
              {(!loading && anketBitti) && <CardContent className={classes.content}><Typography variant="h5" gutterBottom>{mesaj}</Typography></CardContent>}
              {(!loading && !anketBitti) &&
                <Survey.Survey json={anketData}
                  data={formData}
                  onComplete={onComplete}
                  completeText="Formu Tamamla"
                  emptySurvey="Uygun Form Bulunamadı." />
              }
            </div>
            :
            <CardContent className={classes.content}>
              <Typography variant="h5" gutterBottom>
                Başlandı Durumunda fişiniz olmadıgı için formunuz açılamadı.Lütfen ilgili fişinizi başlandı durumuna getiriniz!...
              </Typography>
            </CardContent>
          }
        </Card>
      </Container>
    </Page>
  );
}

export default CookerInformationForm;
